import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { BuscarPersona } from 'src/app/model/persons/buscarpersona.model';
import { AppComponent } from 'src/app/app.component';
import { PersonaService } from 'src/services/persona/persona.service';
import { SweetServices } from 'src/services/sweet.services';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { ComunicacionService } from 'src/services/comunicacion.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ExcelService } from 'src/services/persona/excel.service';
import { AlertasService } from 'src/services/pld/alertas.service';
import { saveAs } from 'file-saver';
import { Helper } from 'src/app/common/Helper/Helper';

import Swal from 'sweetalert2';
import { createWriteStream } from 'streamsaver';
import { AppConstants } from 'src/app/common/enum/app.constants';
import { EnumTipoConsultaOptimizado } from 'src/app/common/enum/TipoPersona.enum';
import { StreamDownloadFetch } from 'src/app/common/Helper/StreamHelper';
import { TableColumn } from '@spot-utils/dynamic-table';
import { PerfilBusqueda } from 'src/app/model/session/perfil-busqueda.model';
import { SessionSotrageService } from 'src/services/session-sotrage.service';

import * as moment from 'moment';

@Component({
  selector: 'app-buscar-persona',
  templateUrl: './buscar-persona.component.html',
  styleUrls: ['./buscar-persona.component.css']
})
export class BuscarPersonaComponent implements OnInit, OnChanges {
  //Stream Download Inicio
  private abortCtrl?: AbortController;
  perfilBusqueda: PerfilBusqueda = new PerfilBusqueda();
  // Variables para componentes de tabla Inicio
  data: any[] = [];
  columns: TableColumn[] = [];
  totalrows: number = 0;
  pageSize: number = 15;
  loadingTotalRows: boolean = false;
  fromSearchButtom: boolean = false;

  // Variables para componentes de tabla Cierre
  @Input('tipoPersona') tipoPersona: number;
  @Input('paraCaso') paraCaso: boolean = false;
  @Input('origenHistorico') origenHistorico: number;
  @Input('open') open: boolean = false;
  @ViewChild('formPersonSearch') formPersonSearch: NgForm;

  persona: BuscarPersona;
  personaResultados: [];
  reporteResultados: any[];
  total: number;
  totalRegistros: number;
  tipoPersonaCombo: number;
  numPage: number;
  contador: number;
  resultadoPaginadoTotal: [];
  personalidadFiscal: [];
  estatus: [];
  sucursales: [];
  areas: [];
  esResultadoMoral: boolean = false;


  generarReporteAsync = () => {
    this.reporteResultados = [];
    let promise = new Promise((resolve, reject) => {
      this.personaService.reporteGeneral(this.persona, this.tipoPersona).subscribe(response => {
        if (response.isCorrect && response.data.info != null) {
          response.data.info.result.forEach(element => {
            delete(element.personaId)
            // tslint:disable-next-line: max-line-length
            var json = JSON.stringify(element)
              .replace("claveCia", "Número de Empleado")
              .replace("nombre","Nombre")
              .replace("apellidoPaterno","Apellido Paterno")
              .replace("apellidoMaterno","Apellido Materno")
              .replace("rfc","RFC")
              .replace("curp","CURP")
              .replace("razonSocialRFC","RFC de la Razón Social")
              .replace("almacenClave","Clave del Almacén")
              .replace("sucursal","Sucursal")
              .replace("area","Área")
              .replace("titulado","Titulado")
              .replace("comite","Comité")
              .replace("oficialCumplimiento","Oficial de Cumplimiento")
              .replace("fechaNacimiento","Fecha de Nacimiento")

            var jsonReporte = JSON.parse(json);
            this.reporteResultados.push(jsonReporte);
          });
          this.excelService.exportAsExcelFile(
            this.reporteResultados,
            this.nameReport(),
            this.nameReport()
          );
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
    return promise;
  }

  constructor(
    private main: AppComponent,
    private personaService: PersonaService,
    private alertaService: AlertasService,
    private excelService: ExcelService,
    private alerta: SweetServices,
    private catalogoService: CatalogosService,
    private comunicacion: ComunicacionService,
    private router: Router,
    private sHelper: StreamDownloadFetch,
    private Helpers: Helper,
    private ssstorage: SessionSotrageService,) {
    this.persona = new BuscarPersona();
    this.tipoPersonaCombo = 2;
    this.personaResultados = [];
    this.personalidadFiscal = this.catalogoService.getPersonalidadFiscal();
    this.estatus = this.catalogoService.getEstatus();
    this.areas = this.catalogoService.getArea();
    this.sucursales = this.catalogoService.getSucursal();
    this.resultadoPaginadoTotal = [];
    this.perfilBusqueda = ssstorage.getPerfilBusqueda();
  }

  reporteClientes = () => {
    let promise = new Promise((resolve, reject) => {
      this.reporteResultados = [];
      this.alerta.AlertaSuccessTimer(
        "El Reporte se descargará en breve, por favor espere"
      )
      this.personaService.buscarReporteClientes(this.persona).subscribe(response => {
        this.main.loading = false;
        if (response == null) {
          this.alerta.AlertaError(
            'Existe un error, si persiste contacte al administrador del Sitio.'
          );
        }
        else if (response.isCorrect === 'false') {
          this.alerta.AlertaError(response.message);
        }
        else if (response.data.total === 0) {
          this.alerta.AlertaSinResultados(response.message);
        }
        else {
          const documento = response.data.info.result;

          // tslint:disable-next-line: no-string-literal
          const byteString = atob(documento[0]['valueArchivo']);
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          let blob = new Blob([ab], { type: documento[0]['fileType'] });
          // tslint:disable-next-line: no-string-literal
          saveAs(blob, documento[0]['fileName']);
          this.alerta.AlertaSuccessTimer('El Reporte se ha generado con éxito.');
        }
      }, (err) => {
        this.main.loading = false;
        this.alerta.AlertaCatch(err);
      });
    });
    return promise;
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.open) {
      this.personaResultados = undefined;
      this.totalRegistros = 0;
      this.persona = new BuscarPersona();
      this.persona.TipoPersona = 2;
    }
  }

  ngOnInit() {
    this.persona.TipoPersona = this.tipoPersona;
    this.main.loading = false;
    this.total = 0;
    this.totalRegistros = 0;
    this.numPage = 0;
    this.contador = 1;
    this.reemplazarCaracter();
  }

  reemplazarCaracter(): void {
    if (this.persona.ApellidoMaterno.includes('?')) {
      this.persona.ApellidoMaterno = this.persona.ApellidoMaterno.replace('?', 'ñ');
    }
    if (this.persona.ApellidoPaterno.includes('?')) {
      this.persona.ApellidoPaterno = this.persona.ApellidoPaterno.replace('?', 'ñ');
    }
    if (this.persona.Nombre.includes('?')) {
      this.persona.Nombre = this.persona.Nombre.replace('?', 'ñ');
    }

  }

  validarFormulario(formPersonSearch: NgForm) {
    if (formPersonSearch.valid) {
      this.persona.BatchNumber =1;
      this.main.loading = true;
      this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
      this.buscarPersona();
       setTimeout(() => {
        this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataCountRows;
        this.bucarTotalesPersonaOptimizado();
      }, 1000);     
    }
  }

   bucarTotalesPersonaOptimizado() {
    this.loadingTotalRows = true;
    this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataCountRows;
    //this.loadingTotalRows = true;
    this.personaService.buscarPersonasConteos(this.persona).subscribe(response => {
      this.loadingTotalRows = false;
      if (response.isCorrect == 'true') {
        var rsp = response.data.info.result;
        this.totalrows = response.totalRegistros;
        this.fromSearchButtom = true;
      }
    }, (err) => {
      this.loadingTotalRows = false;
      if (err.error.message == null) {
        this.alerta.AlertaCatch(err);
      } else {
        this.alerta.AlertaError(err.error.message);
      }
    });
  }
 
  buscarPersona() {
    this.fromSearchButtom = false;
    this.total = 0;
    this.totalRegistros = 0;
    this.esResultadoMoral = this.esMoral();
    this.persona.PersonalidadFiscalId = +this.persona.PersonalidadFiscalId;
    this.persona.AreaId = +this.persona.AreaId;
    this.persona.SucursalId = +this.persona.SucursalId;
    this.persona.NoCuenta = this.persona.NoCuenta;
    this.persona.Historico = this.origenHistorico;
    this.personaResultados = [];
    //this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
    this.personaService.buscar(this.persona).subscribe(response => {
      this.main.loading = false;
      if (response == null) {
        this.alerta.AlertaError(
          'Existe un error, si persiste contacte al administrador del Sitio.'
        );
      } else if (response.isCorrect === 'false') {
        this.persona.Pagina > 1 ? this.persona.Pagina-- : this.persona.Pagina = 1;
        this.alerta.AlertaError(response.message);
      } else if (response.data.total == 0) {
        this.alerta.AlertaSinResultados(response.message);
        this.persona.Pagina > 1 ? this.persona.Pagina-- : this.persona.Pagina = 1;
        this.personaResultados = [];
        this.data = [];
        this.columns = [];
        this.total = 0;
        this.totalRegistros = 0;
        this.totalrows = 0;
        this.alerta.AlertaSinResultados(response.message);
      } else {
        this.data = response.data.info.result.data;
        this.columns = response.data.info.result.columns;
      }
      if (response.data.total) this.totalrows = response.data.total;
    }, (err) => {
      this.main.loading = false;
      this.total = 0;
      this.alerta.AlertaCatch(err);
    });
  }

  esMoral(): boolean {
    const morales = [2, 3];
    return this.persona && morales.includes(
      Number(this.persona.PersonalidadFiscalId));
  }

  onPersonalidadFiscalChange() {
    if (this.esMoral()) {
      this.persona.ApellidoPaterno = '';
      this.persona.ApellidoMaterno = '';
    }
      this.total = 0;
      this.totalRegistros = 0;
      this.numPage = 0;
      this.contador = 1;
      this.personaResultados = [];
  }

  getNombreEncabezado(): string {
    if (this.persona.TipoPersona === 1) {
      return 'Nombre';
    }
    if (this.persona.PersonalidadFiscalId == -1) {
      return 'Nombre/Razón Social';
    }
    return this.esMoral() ? 'Razón Social' : 'Nombre';
  }

  getFechaNacimientoEncabezado(): string {
    if (this.persona.TipoPersona === 1) {
      return 'Fecha de Nacimiento';
    }
    if (this.persona.PersonalidadFiscalId === -1) {
      return 'Fecha de Nacimiento/Constitución';
    }
    return this.esMoral() ? 'Fecha de Constitución' : 'Fecha de Nacimiento';
  }

  cambiarTipoPersona(tipoPersona) {
    this.resultadoPaginadoTotal = [];
    this.total = 0;
    this.totalRegistros = 0;
    if (this.persona.TipoPersona == 2 || this.persona.TipoPersona == 3) {
      this.persona.TipoPersona = +tipoPersona;
      this.tipoPersona = tipoPersona;
    }
  }

  generarReporteGeneral() {
    this.alerta.AlertaSuccessTimer("El Reporte se descargará en breve.")
    this.main.loading = true;
    this.generarReporteAsync().then(response => {
      this.alerta.AlertaSuccessTimer('El Reporte General se ha generado con éxito.');
      this.main.loading = false;
    }).catch(error => this.alerta.AlertaError(error));
    this.main.loading = false;
  }

  nameReport() {
    let nameReporteExcel: string;

    if (this.persona.TipoPersona == 1) {
      nameReporteExcel = "Empleados";
    }
    else if (this.tipoPersonaCombo == 2) {
      nameReporteExcel = "Clientes";
      this.persona.TipoPersona = 2;
    }
    else if (this.tipoPersonaCombo == 3) {
      nameReporteExcel = "PersonasRelacionadas";
      this.persona.TipoPersona = 3;
    }

    return nameReporteExcel;
  }

  detallePersona(personaId: number) {
    this.main.loading = true;
    this.comunicacion.limpiarStorage(false);
    this.comunicacion.setPersona(personaId);
    if (this.persona.TipoPersona == 1) {
      this.comunicacion.setPersonaTipo(this.persona.TipoPersona);
    } else {
      this.comunicacion.setPersonaTipo(this.tipoPersonaCombo);
      this.comunicacion.setCnsHistorica(this.origenHistorico);
    }


    setTimeout(() => {
      this.router.navigate(['/v2/detallepersona']);
    }, 2000);
  }

  onItemChange(value, persona) {
    this.alertaService.buscando = false;
    this.alertaService.persona = persona;
  }

  isValidNumberInput(): boolean {
    return /^\d*$/.test(this.persona.ClaveCia);
  }

  async validateStreamDownload() {
    if (this.totalrows == 0) {
      this.alerta.AlertaSinResultados(`No se encontraron resultados.`);
    } else if (this.totalrows > AppConstants.MAX_ROWS_PER_REPORT_VALIDATE) {
      Swal.fire({
        title: "Consulta demasiado grande",
        html: `El límite máximo de la consulta es ${AppConstants.MAX_ROWS_PER_REPORT_VALIDATE / 1000000}
        millones de filas.`,
        reverseButtons: true
      }).then((rsp) => {
        if (rsp.value) {
          console.log("El usuario aceptó");
        }
      });
    } else {
      this.persona.TipoConsulta = EnumTipoConsultaOptimizado.getDataReport;
      await this.streamDownload();
    }
  }

  async streamDownload() {
    this.abortCtrl = new AbortController();
    this.main.loading = true;
    try {
      var fileName = this.persona.TipoPersona == 1 ? "Empleados" : "Clientes";
      var numExcel = Math.ceil(this.totalrows / AppConstants.MAX_ROWS_PER_EXCEL);
      this.alerta.AlertaSuccessTimer(`Se descargarán ${numExcel} archivos.`);
      const rsp = await this.sHelper.Personas(this.persona, this.abortCtrl.signal);
      if (!rsp.ok) throw new Error("Error en servidor");
      const fileStream = createWriteStream(`${fileName}_${Date.now()}.zip`);
      await rsp.body!.pipeTo(fileStream);
      this.alerta.alertaInfo('Descarga completada');
    } catch (err) {
      this.alerta.AlertaError("Descarga fallida. El navegador limpiará el temporal.");
    } finally {
      this.main.loading = false;
    }
  }

  // funciones de tabla dinamica
  onTableAction(e: { action: string; row: any }) {
    if (e.action === 'detail') {
      this.detallePersona(e.row.personaId)
    }
  }

  onNewBatch(event: { batchNumber: number, page: number }) {
    this.fromSearchButtom = false; 
    this.persona.BatchNumber = event.batchNumber; 
    this.persona.Pagina = event.page;
    this.buscarPersona();
  }

  onPrintReport() {
    this.validateStreamDownload();
  }

}
